/**
 * @file ReceiptFooter.tsx
 * @description Подвал проведённой приёмки: «Движения по документу» и на
 * `≥lg` — «История печати» этикеток (phase19.22, ui-design §1, 1280). На
 * телефоне журнал печати живёт в шторке по ссылке из блока «Этикетки»; на
 * `≥lg` та же ссылка прокручивает сюда (`#label-print-log`), шторку не
 * открывает — иначе история на экране дважды.
 */

import { LabelPrintLog } from "./labels/LabelPrintLog";
import { LABEL_PRINT_LOG_ANCHOR } from "./labels/label-texts";
import type { ReceiptLabels } from "./labels/useReceiptLabels";
import { WmsDocumentMovements } from "./WmsDocumentMovements";
import { SectionLabel } from "../ui/SectionLabel";
import type { GoodsReceiptDto } from "../../lib/api-wms";

interface Props {
  receipt: GoodsReceiptDto;
  labels: ReceiptLabels;
  /** Право печати: без него журнал печати не показываем. */
  canPrint: boolean;
}

export function ReceiptFooter({ receipt, labels, canPrint }: Props) {
  return (
    <div className="flex flex-col gap-6">
      <WmsDocumentMovements documentId={receipt.id} documentKind="receipt" warehouseId={receipt.warehouseId} />
      {canPrint && labels.jobs.length > 0 ? (
        <section id={LABEL_PRINT_LOG_ANCHOR} className="hidden scroll-mt-24 flex-col gap-2 lg:flex">
          <SectionLabel as="h2" count={labels.jobs.length}>
            История печати
          </SectionLabel>
          <LabelPrintLog
            jobs={labels.jobs}
            reprintingId={labels.reprintingId}
            onReprint={(job) => void labels.reprint(job)}
            onHide={labels.hideFile}
            hidingId={labels.hidingId}
          />
        </section>
      ) : null}
    </div>
  );
}
